export default __webpack_public_path__ + "static/media/md3.f72a0895.svg";